import { cx } from "@suse-o11y/class-variance";
import React from "react";

import { TimelineControlElement } from "./TimelineControlElement";

export type TimelinePlayHeadTheme = "default" | "light" | "dark" | "purple" | "red";

export interface TimelinePlayHeadProps {
	theme?: TimelinePlayHeadTheme;
	x?: number;
	/**
	 * @default true
	 */
	showDot?: boolean;
	className?: string;
}

export const TimelinePlayHead: React.FC<React.PropsWithChildren<TimelinePlayHeadProps>> = ({
	theme = "default",
	x,
	showDot = true,
	children,
	className,
}) => (
	<TimelineControlElement className={cx("pointer-events-none", className)} x={x}>
		{/* timestamp and text */}
		<div
			className={cx(
				"absolute top-0 -translate-x-1/2 whitespace-nowrap rounded-xs border border-solid px-[5px] text-11/[18px]",
				theme === "default" && "bg-white text-grey-800",
				theme === "light" && "bg-white text-grey-600",
				theme === "dark" ? "border-grey-800 bg-grey-800 text-white" : "border-current",
				theme === "red" && "bg-red-100 text-red-500",
				theme === "purple" && "bg-purple-100 text-purple-500",
			)}
		>
			{children}
		</div>

		{/* line */}
		<div
			className={cx(
				"h-full w-px bg-grey-800",
				theme === "light" && "bg-grey-600",
				theme === "red" && "bg-red-500",
				theme === "purple" && "bg-purple-500",
			)}
		/>

		{/* dot */}
		{showDot && (
			<div
				className={cx(
					"absolute bottom-0 -left-0.5 h-[5px] w-[5px] rounded-full border border-solid",
					theme === "default" && "border-grey-800 bg-white",
					theme === "light" && "border-grey-600",
					theme === "dark" && "border-grey-800 bg-grey-800",
					theme === "red" && "border-red-500",
					theme === "purple" && "border-purple-500",
					theme === "dark" ? "bg-grey-800" : "bg-white",
				)}
			/>
		)}
	</TimelineControlElement>
);
